import React from "react";
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import uiManager from '../../../config/ui.js';

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Bike',
      attr: 'bike_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Service Center',
      attr: 'service_center_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer',
      value: (row) => {
        return <>
          <span>{row.rental_customer?.cus_nomenclature_id}</span><br/>
          <span>{row.rental_customer?.name}</span>
        </>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Continued',
      value: (row) => {
        return row.remaining_continuation_count == 0 ? "False" : `True - ${row.remaining_continuation_count}`
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Lease Offer',
      value: (row) => {
        if (row.customer_lease_offer_name){
          return row.customer_lease_offer_name
        } else{
          return "-"
        }
     
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at'
    },
  ]

  return <>
    <ListingComponent
      key={'rental_bookings_list'}
      breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Rental Customers List", url: '/rental_customers' }]}
      listingMutation={getApi('rental_bookings')}
      params={props.params}
      className="rental-bookings-listing-page"
      contentHeading="Rental Bookings List - Results"
      headers={headers}
      recordsKey="rental_bookings"
    />
  </>
};

export default Listing;
